import { useEffect } from 'react'
import styled from 'styled-components/macro'

import { IconClose } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import ImgBackground from 'legacy/assets/img/app-suggestion-bg.jpeg'
import ImgIconLoads from 'legacy/assets/svg/icons/icon_loads_app.svg'
import { I18n } from 'legacy/components/I18n/i18n'
import { useLocalStorageState } from 'legacy/utils/hooks/useLocalStorageState'
import { useMobileOS } from 'legacy/utils/hooks/useMobileOS'

import { useAnalytics } from '../hooks/useAnalytics'

export const DISMISSED_SUGGESTION_STORAGE_KEY = 'loadsmart.loadsAppSuggestion.dismissed'

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1100;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: space-between;
  width: 100%;
  height: 80px;
  padding: 10px 14px 10px 10px;

  color: ${getToken('color-neutral-white')};

  background-color: ${getToken('color-success-dark')};

  background-image: ${ImgBackground};
  background-size: cover;
`

const Message = styled.div`
  margin: 0 14px;

  font-size: 12px;
  line-height: 16px;

  strong {
    font-size: 14px;
  }
`

const CloseButtonWrapper = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  padding: 0;

  background-color: ${getToken('color-neutral-lighter')};
  border: none;
  border-radius: 50%;
`

const StyledIconClose = styled(IconClose)`
  width: 14px;
  height: 14px;

  color: ${getToken('color-neutral')};
`

function AppSuggestion() {
  const { isMobileOS } = useMobileOS()
  const [dismissed, setDismissed] = useLocalStorageState(DISMISSED_SUGGESTION_STORAGE_KEY, false)
  const { analytics } = useAnalytics()

  const isVisible = isMobileOS && !dismissed

  useEffect(() => {
    if (isVisible) analytics.track(['App Suggestion Banner', 'View'])
  }, [analytics, isVisible])

  if (!isVisible) return null

  return (
    <a href={process.env.REACT_APP_LOADS_APP_URL}>
      <Container>
        <img src={ImgIconLoads} alt="Loads App Icon" width="60" height="60" />
        <Message>
          <strong>{I18n.get('lb.appSuggestion.message')}</strong>
          <br />
          {I18n.get('lb.appSuggestion.download')}
        </Message>
        <CloseButtonWrapper
          onClick={event => {
            event.preventDefault()
            setDismissed(true)
            analytics.track(['App Suggestion Banner', 'Dismiss'])
          }}
          title={I18n.get('lb.appSuggestion.dismiss')}
        >
          <StyledIconClose />
        </CloseButtonWrapper>
      </Container>
    </a>
  )
}

export { AppSuggestion }
